// import payeplast_tanitim from "./payeplast_tanitim2.mp4";
// const payeplast_tanitim = "https://firebasestorage.googleapis.com/v0/b/payeplast-web.appspot.com/o/images%2FgaleryImg%2Fpayeplast_tanitim2.mp4?alt=media&token=acb4dd7b-75ab-444f-a2f6-a946adcaa96c";
const payeplast_tanitim = "nZUNy0kxryI";

export const videos = {
  payeplast_tanitim,
};
